
import CheckoutComplete from '~/pages/_lang/checkout/complete/_orderId.vue'
export default CheckoutComplete
